export default __webpack_public_path__ + "static/media/baby 7.e85674d1.png";